module.exports = __webpack_public_path__ + "first-10-front.jpg?7c9b301749eec7de549e838cfcdd0faa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-front.jpg
// module id = 399
// module chunks = 0